import styled from "styled-components";

import { Button, colors, radii, shadows } from "shared/ui";

export const Plans = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Plan = styled.div`
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
    padding: 16px 18px;
    transition: box-shadow 0.2s;

    &:hover {
        box-shadow: ${shadows.panel};
    }
`;

export const PlanHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
`;

export const PlanTitle = styled.div`
    font-size: 1.0625rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const PlanPrice = styled.div`
    margin-top: 4px;
    font-size: 14px;
    color: ${colors.textSecondary};
`;

export const CurrentMark = styled.span`
    margin-left: 8px;
    padding: 2px 8px;
    border-radius: ${radii.small};
    background: ${colors.infoBg};
    font-size: 12px;
    font-weight: 500;
    color: ${colors.primary};
`;

export const PlanActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

// Ширину фиксируем: иначе «Продлить» и «Подключить» разъезжают колонку действий по строкам.
export const PlanButton = styled(Button)`
    min-width: 148px;
`;

export const ToggleDetailsCell = styled.div`
    min-width: 84px;
    text-align: right;
`;

export const ToggleDetails = styled.button`
    padding: 0;
    border: 0;
    background: none;
    font-size: 13px;
    color: ${colors.primary};
    cursor: pointer;

    &:focus-visible {
        outline: 2px solid ${colors.primary};
        outline-offset: 2px;
    }
`;

export const FeatureList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 14px;
`;

export const Feature = styled.div<{ $included: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: ${({ $included }) => ($included ? colors.textPrimary : colors.textSecondary)};

    svg {
        flex: 0 0 auto;
        color: ${({ $included }) => ($included ? colors.success : colors.fieldBorder)};
    }
`;
